<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      :title="data.StayQualification?'取消留宿资格':'恢复留宿资格'"
      id-key="LeaveId"
      :data="data"
      :form-label-width="data.StayQualification?'80px':'40px'"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:14" v-if="data.StayQualification==1">
            <el-form-item label="取消原因" prop="CancelRemark">
              <el-select v-model="data.CancelRemark" filterable allow-create>
                <el-option value="扣分累计"></el-option>
                <el-option value="过密"></el-option>
                <el-option value="手机"></el-option>
                <el-option value="其他"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="r-form" label="备注" prop="Remark">
              <el-input size="mini" type="textarea" style="width:100%" v-model="data.Remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/st/studentclass").default,
      data: {
        Remark: "",
        StudentClassId: 0,
        TermId: 0,
        StudentId: 0,
        ClassId: 0,
        DisciplinePoint: 0,
        StayQualification: 1,
        CancelDate: "",
        CancelRemark: "",
        ResumeDate: "",
      },
      isMB: this.$store.state.isMB,
      rules: {
        CancelRemark: [{ required: true, message: "取消原因不能为空" }],
        // Remark: [{ required: true, message: "备注不能为空" }],
      },
    };
  },
  methods: {
    onCreateOpened(data) {
      
    },
    onEditOpened(row) {
      this.data.Remark = "";
    },
    onClosed() {
      
    },
    onBeforeSave() {
      this.loading(true);
      if(this.data.StayQualification == 1) {
        this.api.cancel({
          ...this.data,
          ResumeDate: "",
          CancelDate: this.$commonJs.getToday(),
          StayQualification: 0,
        }).then(res => {
          this.loading(false);
          if(res.Code==0) {
            this.close(true);
            this.$message.success(res.Msg);
            this.$emit('close-saved');
          } else {
            this.$message.error(res.Msg);
          }
        })
      } else {
        this.api.resume({
          ...this.data,
          ResumeDate: this.$commonJs.getToday(),
          CancelDate: "",
          StayQualification: 1,
        }).then(res => {
          this.loading(false);
          if(res.Code==0) {
            this.close(true);
            this.$message.success(res.Msg);
            this.$emit('close-saved');
          } else {
            this.$message.error(res.Msg);
          }
        })
      }
      return false;
    },
  },
};
</script>
<style lang="scss">
.r-form {
  margin-bottom: 0 !important;
}
</style>